import { useTranslation } from 'react-i18next';
import { COLORS } from '../../constants';
import { useNavbarData } from '../../hooks/useNavbarData';
import { Link } from '../common/buttons';
import Icon, { iconNames } from '../common/icon';
import { accountRoutes } from '../../constants/routes';

export const AuthButton = ({ onClose }) => {
    const { t } = useTranslation();
    const { onLogoutClick, isAuthenticated } = useNavbarData();

    const linkClassName = 'nav__item url';

    const handleLinkClick = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleLogoutClick = () => {
        onLogoutClick();
        if (onClose) {
            onClose();
        }
    };

    const renderButtonContent = () =>
        isAuthenticated ? (
            <>
                <Icon
                    name={iconNames.key}
                    size={24}
                    fill={COLORS.DARKRED_LIGHT}
                />
                <Link
                    to={accountRoutes.CABINET}
                    className={linkClassName}
                    text={<b>{t('cabinet')}</b>}
                    onClick={handleLinkClick}
                />
                <button type="button" onClick={handleLogoutClick} className="btn-exit">
                    <Icon
                        name={iconNames.exit}
                        size={24}
                        fill={COLORS.DARKRED_LIGHT}
                    />
                </button>
            </>
        ) : (
            <>
                <Icon
                    name={iconNames.key}
                    size={24}
                    fill={COLORS.DARKRED_LIGHT}
                />
                <Link
                    to={accountRoutes.LOGIN}
                    className={linkClassName}
                    text={<b>{t('enter')}</b>}
                    onClick={handleLinkClick}
                />
            </>
        );

    return <div style={{ display: 'flex' }}>{renderButtonContent()}</div>;
};
